import { IconFont } from '@/components/IconFont'
import { deleteMemberGroup, getOrganizationMemberGroups } from '@/services/member/member'
import { useRequest } from 'ahooks'
import { Button, List, Row, Typography } from 'antd'
import React, { memo, useContext } from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { OrganizationContext } from '../../..'
import AddGroup from './AddGroup'

export default memo(function OrganizationGroupList() {
  const navigate = useNavigate()
  const orgData = useContext(OrganizationContext).orgData!
  const { data: groups = [], refresh } = useRequest(() => getOrganizationMemberGroups(orgData.id))
  const { run: deleteGroup } = useRequest(deleteMemberGroup, {
    manual: true,
    onSuccess: () => {
      refresh()
    }
  })

  return (
    <div>
      <Row justify={'space-between'} align={'middle'}>
        <Typography.Title level={4}>Organization Group List</Typography.Title>

        <Button>
          <Link to={'../..'}>
            <IconFont type='icon-fanhui' />
          </Link>
        </Button>
      </Row>

      <List
        className={'mt-2'}
        header={
          <Row justify={'end'}>
            <AddGroup
              trigger={
                <Button type={'primary'} icon={<IconFont type='icon-add' />}>
                  New group
                </Button>
              }
              onSuccess={() => {
                refresh()
              }}
            />
          </Row>
        }
        itemLayout='horizontal'
        dataSource={groups}
        renderItem={(group) => (
          <List.Item
            key={group.id}
            actions={[
              <IconFont
                key={`${group.id}_edit`}
                type={'icon-edit'}
                onClick={() =>
                  navigate(`../${group.id}`, {
                    state: group
                  })
                }
              />,

              <IconFont
                key={`${group.id}_delete`}
                type={'icon-shanchu'}
                onClick={() => {
                  deleteGroup(orgData.id, group.id)
                }}
              />
            ]}
          >
            {group.name}
          </List.Item>
        )}
      />
    </div>
  )
})
